import { BorderRadii, FontFamilies, FontSizes, satosRed, Spacings } from './designTokens';
import { createTheme } from '@mui/material/styles';
import { grey } from '@mui/material/colors';

export const theme = createTheme({
  colorSchemes: {
    light: {
      palette: {
        satosRed,
        background: {
          default: 'hsl(0, 0%, 96%)',
        },
        shades: {
          red: 'rgba(28, 20, 20, 1)',
          green: 'rgba(20, 22, 20, 1)',
          neutral: 'rgba(5, 5, 5, 0.5)',
        },
      },
    },
    dark: {
      palette: {
        satosRed,
        text: {
          primary: grey[50],
          secondary: grey[500],
        },
        background: {
          default: 'hsl(0, 0%, 8%)',
          paper: 'hsl(0, 0%, 8%)',
        },
        shades: {
          red: 'rgba(28, 20, 20, 1)',
          green: 'rgba(20, 22, 20, 1)',
          neutral: 'rgba(5, 5, 5, 0.5)',
        },
      },
    },
  },
  cssVariables: {
    colorSchemeSelector: 'data',
  },
  typography: {
    fontFamily: FontFamilies.sourceSans,
  },
  borderRadii: {
    br8: BorderRadii.br8,
    br12: BorderRadii.br12,
  },
  fontSizes: {
    f12: FontSizes.f12,
    f14: FontSizes.f14,
    f16: FontSizes.f16,
    f18: FontSizes.f18,
    f20: FontSizes.f20,
    f24: FontSizes.f24,
    f30: FontSizes.f30,
    f36: FontSizes.f36,
    f48: FontSizes.f48,
    f60: FontSizes.f60,
    f72: FontSizes.f72,
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: ({ theme }) => ({
          backgroundColor: theme.vars.palette.background.paper,
          color: theme.vars.palette.text.primary,
          fontSize: theme.fontSizes.f12,
          fontWeight: 500,
          fontFamily: theme.typography.fontFamily,
          border: `1px solid ${theme.vars.palette.divider}`,
          borderRadius: 4,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
          ...theme.applyStyles('dark', {
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          }),
        }),
      },
    },
  },
  spacings: {
    s4: Spacings.s4,
    s8: Spacings.s8,
    s12: Spacings.s12,
    s16: Spacings.s16,
    s20: Spacings.s20,
    s24: Spacings.s24,
    s32: Spacings.s32,
    s48: Spacings.s48,
    s64: Spacings.s64,
    s80: Spacings.s80,
    s96: Spacings.s96,
    s128: Spacings.s128,
    s192: Spacings.s192,
    s256: Spacings.s256,
    s384: Spacings.s384,
    s512: Spacings.s512,
    s640: Spacings.s640,
    s768: Spacings.s768,
  },
});
